import { useQuery } from "@tanstack/react-query";
import { getBillingMetricsAction } from "../actions/getBillingMetrics.action";

export const BILLING_METRICS_QUERY_KEY = "superadmin-billing-metrics";

export const useBillingMetricsQuery = () => {
  const token = sessionStorage.getItem("token");

  return useQuery({
    queryKey: [BILLING_METRICS_QUERY_KEY],
    queryFn: getBillingMetricsAction,
    enabled: !!token,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 2, // 2 minutes
  });
};
